(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Process each categories-tabs-section independently
    document.querySelectorAll('.categories-tabs-section').forEach(function(section) {
      // Skip if already initialized
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const tabs = section.querySelectorAll('.tab-cta');
      const categoryCards = section.querySelectorAll('.category-card');
      const productCards = section.querySelectorAll('.product-card');
      const scrollContainer = section.querySelector('.scroll');
      const leftArrow = section.querySelector('.scroll-left');
      const rightArrow = section.querySelector('.scroll-right');

      // Tab filtering with dual behavior
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();

          // Update active tab
          tabs.forEach(function(t) { t.classList.remove('active'); });
          tab.classList.add('active');

          const category = tab.dataset.category;

          if (category === 'all') {
            // Hide all product cards
            productCards.forEach(function(card) {
              card.classList.add('hiding');
              card.style.opacity = '';
              card.style.transform = '';
            });

            // Show category cards
            categoryCards.forEach(function(card) {
              card.classList.remove('hiding');
              card.style.opacity = '';
              card.style.transform = '';
            });
          } else {
            // Hide all category cards
            categoryCards.forEach(function(card) {
              card.classList.add('hiding');
              card.style.opacity = '';
              card.style.transform = '';
            });

            // Show only products from selected category
            productCards.forEach(function(card) {
              const cardCategory = card.dataset.productCard;
              card.style.opacity = '';
              card.style.transform = '';

              if (cardCategory === category) {
                card.classList.remove('hiding');
              } else {
                card.classList.add('hiding');
              }
            });
          }

          // Reset scroll position
          if (scrollContainer) {
            scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });
      });

      // Horizontal scroll with arrows
      if (scrollContainer && leftArrow && rightArrow) {
        const scrollAmount = 300;

        leftArrow.addEventListener('click', function() {
          scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        rightArrow.addEventListener('click', function() {
          scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        // Show/hide arrows based on scroll position
        const updateArrows = function() {
          const scrollLeft = scrollContainer.scrollLeft;
          const scrollWidth = scrollContainer.scrollWidth;
          const clientWidth = scrollContainer.clientWidth;

          if (scrollLeft > 0) {
            leftArrow.classList.add('show');
          } else {
            leftArrow.classList.remove('show');
          }

          if (scrollLeft + clientWidth < scrollWidth - 10) {
            rightArrow.classList.add('show');
          } else {
            rightArrow.classList.remove('show');
          }
        };

        scrollContainer.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      // Mouse drag scrolling
      if (scrollContainer) {
        let isDown = false;
        let startX;
        let scrollLeftPos;
        let hasMoved = false;

        scrollContainer.addEventListener('mousedown', function(e) {
          if (e.button !== 0) return;
          isDown = true;
          hasMoved = false;
          scrollContainer.classList.add('dragging');
          startX = e.pageX;
          scrollLeftPos = scrollContainer.scrollLeft;
        });

        document.addEventListener('mouseup', function() {
          if (isDown) {
            isDown = false;
            scrollContainer.classList.remove('dragging');
          }
        });

        document.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          e.preventDefault();
          const walk = startX - e.pageX;
          if (Math.abs(walk) > 5) {
            hasMoved = true;
          }
          scrollContainer.scrollLeft = scrollLeftPos + walk;
        });

        // Prevent click on links if dragged
        scrollContainer.querySelectorAll('a').forEach(function(link) {
          link.addEventListener('click', function(e) {
            if (hasMoved) {
              e.preventDefault();
            }
          });
          // Prevent native drag behavior
          link.addEventListener('dragstart', function(e) {
            e.preventDefault();
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-ifdesign"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sectionEl = document.getElementById('shopify-section-{{ section.id }}');
    if (!sectionEl) return;

    const toggles = sectionEl.querySelectorAll('[data-footer-toggle]');
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    const closeAll = () => {
      toggles.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.closest('.footer-links__col')?.classList.remove('is-open');
      });
    };

    toggles.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        if (!isMobile()) return;
        const col = button.closest('.footer-links__col');
        const isOpen = col?.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          col?.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        toggles.forEach(btn => {
          btn.setAttribute('aria-expanded', 'true');
          btn.closest('.footer-links__col')?.classList.add('is-open');
        });
      } else {
        closeAll();
      }
    }, { passive: true });

    if (!isMobile()) {
      toggles.forEach(btn => {
        btn.setAttribute('aria-expanded', 'true');
        btn.closest('.footer-links__col')?.classList.add('is-open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-articles-ifdesign"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sectionEl = document.getElementById('shopify-section-{{ section.id }}');
    if (!sectionEl) return;

    const scrollContainer = sectionEl.querySelector('[data-scroll-container]');
    const leftArrow = sectionEl.querySelector('.scroll-left');
    const rightArrow = sectionEl.querySelector('.scroll-right');

    if (!scrollContainer || !leftArrow || !rightArrow) return;

    const scrollAmount = 400;

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      leftArrow.classList.toggle('disabled', scrollLeft <= 0);
      rightArrow.classList.toggle('disabled', scrollLeft + clientWidth >= scrollWidth - 4);
    };

    leftArrow.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    scrollContainer.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // View toggle functionality
  function initViewToggle() {
    const toggleContainer = document.querySelector('[data-collection-view-toggle]');
    if (!toggleContainer) return;

    const buttons = toggleContainer.querySelectorAll('[data-view-columns]');
    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    // Restore saved preference
    const savedColumns = localStorage.getItem('collection-view-columns');
    if (savedColumns) {
      grid.setAttribute('data-columns', savedColumns);
      buttons.forEach(btn => {
        const isActive = btn.getAttribute('data-view-columns') === savedColumns;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive);
      });
    } else {
      // Default to 4 columns
      grid.setAttribute('data-columns', '4');
    }

    // Handle button clicks
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const columns = button.getAttribute('data-view-columns');

        // Update grid
        grid.setAttribute('data-columns', columns);

        // Update buttons
        buttons.forEach(btn => {
          const isActive = btn === button;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive);
        });

        // Save preference
        localStorage.setItem('collection-view-columns', columns);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewToggle);
  } else {
    initViewToggle();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-login"]) return;
  try {
    
  const recoverLink = document.getElementById('RecoverPassword');
  const hideLink = document.getElementById('HideRecoverPassword');
  const recoverDiv = document.getElementById('recover');
  if (recoverLink && recoverDiv) {
    recoverLink.addEventListener('click', (e) => { e.preventDefault(); recoverDiv.style.display = 'block'; });
  }
  if (hideLink && recoverDiv) {
    hideLink.addEventListener('click', (e) => { e.preventDefault(); recoverDiv.style.display = 'none'; });
  }
  if (window.location.hash === '#recover' && recoverDiv) {
    recoverDiv.style.display = 'block';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Process each recommended-collections-section independently
    document.querySelectorAll('.recommended-collections-section:not(.hidden)').forEach(function(section) {
      const scrollContainer = section.querySelector('.scroll');

      if (scrollContainer) {
        // Mouse drag scrolling
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;

        scrollContainer.addEventListener('mousedown', function(e) {
          isDown = true;
          hasMoved = false;
          scrollContainer.classList.add('dragging');
          startX = e.pageX - scrollContainer.offsetLeft;
          scrollLeft = scrollContainer.scrollLeft;
        });

        scrollContainer.addEventListener('mouseleave', function() {
          isDown = false;
          scrollContainer.classList.remove('dragging');
        });

        scrollContainer.addEventListener('mouseup', function() {
          isDown = false;
          scrollContainer.classList.remove('dragging');
        });

        scrollContainer.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - scrollContainer.offsetLeft;
          const walk = (x - startX) * 1.5;
          if (Math.abs(walk) > 5) {
            hasMoved = true;
          }
          scrollContainer.scrollLeft = scrollLeft - walk;
        });

        // Prevent click on links if dragged
        scrollContainer.querySelectorAll('a').forEach(function(link) {
          link.addEventListener('click', function(e) {
            if (hasMoved) {
              e.preventDefault();
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
